// Rate limiting utility for preventing spam and abuse
class RateLimiter {
  constructor(key, maxAttempts, windowMs) {
    this.key = key;
    this.maxAttempts = maxAttempts;
    this.windowMs = windowMs;
  }

  canAttempt() {
    const now = Date.now();
    const attempts = this.getAttempts();
    // Filter out attempts outside the time window
    const validAttempts = attempts.filter(time => now - time < this.windowMs);
    
    if (validAttempts.length >= this.maxAttempts) {
      const oldestAttempt = Math.min(...validAttempts);
      const timeUntilReset = this.windowMs - (now - oldestAttempt);
      return { allowed: false, timeUntilReset };
    }
    
    return { allowed: true };
  }

  recordAttempt() {
    const now = Date.now();
    const attempts = this.getAttempts();
    // Keep only attempts within the window to prevent localStorage bloat
    const validAttempts = attempts.filter(time => now - time < this.windowMs);
    validAttempts.push(now);
    localStorage.setItem(this.key, JSON.stringify(validAttempts));
  }

  getAttempts() {
    try {
      const stored = localStorage.getItem(this.key);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      // Handle corrupted localStorage data
      return [];
    }
  }

  getRemainingTime() {
    const result = this.canAttempt();
    return result.allowed ? 0 : result.timeUntilReset;
  }

  reset() {
    localStorage.removeItem(this.key);
  }
}

// Pre-configured rate limiters for different actions
export const signupLimiter = new RateLimiter('signup_attempts', 5, 3600000); // 3 attempts per hour
export const registrationLimiter = new RateLimiter('registration_attempts', 5, 300000); // 5 attempts per 5 minutes
export const loginLimiter = new RateLimiter('login_attempts', 15, 900000); // 15 attempts per 15 minutes

export default RateLimiter;